import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalInfo, UserInfo } from 'src/app/models';
import { SourceMoveTo, MoveTo } from 'src/app/models/move-to.model';
import { WorkspaceService, ToastService } from 'src/app/services';
import { DeleteModalComponent } from '..';
import { Response } from 'src/app/models/deleted-items.model';

@Component({
    selector: 'app-move-to',
    templateUrl: './move-to.component.html',
    styleUrls: ['./move-to.component.scss'],
    standalone: false
})
export class MoveToComponent implements OnInit {

  // this is what to move
  @Input() source: SourceMoveTo;
  // tslint:disable-next-line: no-output-native
  @Output() submit = new EventEmitter();
  private selected: MoveTo;
  validation: boolean;

  constructor(
    public activeModal: NgbActiveModal,
    public toastService: ToastService,
    private workspaceService: WorkspaceService,
    public modalService: NgbModal
  ) {
  }

  async ngOnInit() { }

  handleDestination($event: MoveTo) {
    this.selected = $event;
  }

  /**
   * Modal submit. Move entity to selected workspace/project/folder and sends info to the parent component
   */

  async onSubmit() {
    if (!this.selected) {
      this.validation = true;
    } else {
      this.validation = false;
      try {
        
        let response = (await this.workspaceService.checkRequiredConfirmToMoveTo(this.selected));
        if(response.status) // required confirm
        {
          this.openConfirmModal(response);
        }else{
          this.MoveTo();
        }
      
      } catch (error) {
        this.toastService.showError(error.error);
        console.error('error =>', error);
      }
    }
  }

  /**
   * Close modal
   */

  onDelete() {
    this.activeModal.close();
  }


   /**
   * Call the API to move the entity and close the modal
   */

  async MoveTo() {
    await this.workspaceService.moveProjectOrItem(this.selected);
    this.activeModal.close();
    this.submit.emit();
  }



  /**
   * Opens the modal to confirm to move the entity to the new parent 
   */

  openConfirmModal(response: Response) {
    const modalRef = this.modalService.open(DeleteModalComponent, { centered: true, size: '50%', backdrop: 'static' });  
    let title: string;    
    title = `Are you sure to move <span class="item-name">${this.source.data.name}</span> ?`  ;
    
    modalRef.componentInstance.data = {
      id: this.source.data.id,
      type: this.source.data.type,
      name: this.source.data.name,
      title,
      description: `The ${this.selected.parent_type} ${response.detail} is shared with users of different companies.` ,
      button: 'Confirm',
      selector: '' };
    modalRef.componentInstance.delete.subscribe((receivedEntry: ModalInfo) => {
      this.MoveTo();
    });
  }

}


